import TransactionRepository from '../../repositories/TransactionRepository';
import {
    HANDLE_MENU_COLLAPSED,
    HANDLE_REFERRAL_FLAGGED,
    HANDLE_SELECT_REFERRAL,
    HANDLE_BILLINGS_COUNT,
} from '../constants/layout-action-types';

export const handleMenuCollapsed = (value) => {
    return async (dispatch) => {
        dispatch({
            type: HANDLE_MENU_COLLAPSED,
            payload: value,
        });
    };
};

export const handleReferralFlagged = (value) => {
    return async (dispatch) => {
        dispatch({
            type: HANDLE_REFERRAL_FLAGGED,
            payload: value,
        });
    };
};

export const handleSelectReferral = (value) => {
    return async (dispatch) => {
        dispatch({
            type: HANDLE_SELECT_REFERRAL,
            payload: value,
        });
    };
};

export const handlePendingTransactions = (referralId, payload) => {
    return async (dispatch) => {
        try {
            let reqObj = payload || {
                page: 0,
                pageSize: 10,
                onlyPending: true,
                type: 'inporocess',
                onlyCount: true,
            };
            const result = await TransactionRepository.getBillings(
                referralId,
                reqObj,
            );
            if (result.data.success) {
                dispatch({
                    type: HANDLE_BILLINGS_COUNT,
                    payload: result.data.data.total,
                });
            } else {
                dispatch({
                    type: HANDLE_BILLINGS_COUNT,
                    payload: 0,
                });
            }
        } catch (e) {
            console.log(e.response);
            dispatch({
                type: HANDLE_BILLINGS_COUNT,
                payload: 0,
            });
        }
    };
};
